import { IconType } from 'react-icons';
import { styled } from 'styled-components';
import { IoFileTrayFullOutline } from 'react-icons/io5';

import IconButton from 'components/ui/IconButton';

const Container = styled.aside`
  height: 100%;
  width: 240px;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

interface SideBarProps {
  selectedCategory: string;
  categories: {
    key: string;
    name: string;
    icon: IconType;
  }[];
  onCategoryClick: (categoryKey: string) => void;
}

const SideBar = ({ selectedCategory, categories, onCategoryClick }: SideBarProps) => {
  return (
    <Container>
      <IconButton
        $size={44}
        $isFull
        $isSelected={selectedCategory === 'all'}
        $hasRadius
        onClick={() => onCategoryClick('all')}
      >
        <IoFileTrayFullOutline />
        <span>전체</span>
      </IconButton>
      {categories.map((category) => (
        <IconButton
          key={category.key}
          $size={44}
          $isFull
          $isSelected={category.key === selectedCategory}
          $hasRadius
          onClick={() => onCategoryClick(category.key)}
        >
          <category.icon />
          <span>{category.name}</span>
        </IconButton>
      ))}
    </Container>
  );
};

export default SideBar;
